// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { themr } from "react-css-themr";
import { Page, Button } from "@lifepay/rc-ui-toolkit";
import { connect } from "react-redux";
import { Lock } from "@lifepay/redux-subsystem-access";
import { LOCK_KEYS } from "accessConfig";

// ABSOLUTE PATH IMPORTS
// import selectors from "model/selectors";

// RELATIVE PATH IMPORTS
import styles from "./FrontPage.m.scss";

@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {};
  },
  // mapDispatchToProps object - pass individual action creators here
  {}
)
@themr("front-page", styles)
export default class FrontPage extends Component {
  static propTypes = {
    theme: PropTypes.object, // object with css class names
    history: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      pageHeader: "Меню оператора",
    };
  }

  setHeader = ({ pageHeader }) => {
    this.setState({ pageHeader });
  };

  render() {
    const { theme, history } = this.props;
    const { pageHeader } = this.state;

    return (
      <Page header={pageHeader}>
        <div className={classnames(theme.wrapper)}>
          <div className={classnames(theme.content)}>
            <div className={classnames(theme.inner)}>
              <Lock
                lockId={LOCK_KEYS.CALLCENTER_WORKFLOW_ACCESS}
                type={"lock"}
                theme={{
                  wrapper: theme.button,
                }}
              >
                <Button
                  type={"alt"}
                  size={"medium"}
                  onClick={() => {
                    history.push("/client");
                  }}
                  theme={{
                    wrapper: theme.button,
                  }}
                >
                  {"Найти клиента"}
                </Button>
              </Lock>
              <Lock
                lockId={LOCK_KEYS.PROCESSING_WORKFLOW_ACCESS}
                type={"lock"}
                theme={{
                  wrapper: theme.button,
                }}
              >
                <Button
                  type={"alt"}
                  size={"medium"}
                  onClick={() => {
                    history.push("/processing");
                  }}
                  theme={{
                    wrapper: theme.button,
                  }}
                >
                  {"Процессинг"}
                </Button>
              </Lock>
              <Lock
                lockId={LOCK_KEYS.ADMIN_WORKFLOW_ACCESS}
                type={"lock"}
                theme={{
                  wrapper: theme.button,
                }}
              >
                <Button
                  type={"alt"}
                  size={"medium"}
                  onClick={() => {
                    history.push("/admin");
                  }}
                  theme={{
                    wrapper: theme.button,
                  }}
                >
                  {"Администрирование"}
                </Button>
              </Lock>
            </div>
          </div>
        </div>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/FrontPage/FrontPage.js